"use server";

import { revalidatePath } from "next/cache";
import { setSelectedFiscalYearId } from "@/lib/fiscalYearSelection";
import { requireUser } from "@/lib/auth/currentUser";

/**
 * 表示する会計期間を切り替える。空文字（または未指定）は選択解除＝当期に戻す。
 * data/active-fiscal-year.json への書込＝全利用者共有の表示状態を変えるため、
 * 最低限ログイン済みであることを要求する（switchBookActionとは異なり閲覧のみロールでも許可）。
 */
export async function switchFiscalYearAction(formData: FormData): Promise<void> {
  await requireUser();
  const raw = formData.get("fiscalYearId");
  const id = raw && String(raw) !== "" ? Number(raw) : null;
  setSelectedFiscalYearId(id != null && Number.isFinite(id) ? id : null);
  // レポート・仕訳帳・元帳など、期間に依存する全画面を再検証
  revalidatePath("/", "layout");
}
